import { useTranslation } from "react-i18next";

export default function OnzeWaarden() {
  const { t } = useTranslation("wie-zijn-wij");
  const cards = t("onzeWaarden.cards", { returnObjects: true }) as Array<{
    title: string;
    desc: string;
    icon: string;
  }>;

  return (
    <section className="bg-brand-cream py-16 md:py-24 w-full">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight text-center mb-10 md:mb-14">
          {t("onzeWaarden.h2")}
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card, i) => (
            <div
              key={i}
              className="bg-white rounded-xl p-6 md:p-8 border border-brand-border hover:border-brand-yellow transition-colors"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-brand-yellow mb-4 md:mb-5">
                <i className={`${card.icon} text-brand-text text-lg w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <h3 className="font-geist font-bold text-lg md:text-xl text-brand-text mb-2 md:mb-3">
                {card.title}
              </h3>
              <p className="font-geist text-sm md:text-base text-brand-text/70 leading-relaxed">
                {card.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}